import React, { createContext, useContext, useState, ReactNode } from 'react';

interface AdminMenuContextType {
  isMobileMenuOpen: boolean;
  toggleMobileMenu: () => void;
  closeMobileMenu: () => void;
}

const defaultContextValue: AdminMenuContextType = {
  isMobileMenuOpen: false,
  toggleMobileMenu: () => {},
  closeMobileMenu: () => {},
};

const AdminMenuContext = createContext<AdminMenuContextType>(defaultContextValue);

export const AdminMenuProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(prev => !prev);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <AdminMenuContext.Provider value={{ isMobileMenuOpen, toggleMobileMenu, closeMobileMenu }}>
      {children}
    </AdminMenuContext.Provider>
  );
};

export const useAdminMenu = () => {
  return useContext(AdminMenuContext);
};
